/**
 * The room's invite sheet: what it lists and says.
 */

/** The invites sent to someone's address, not the lesson's own link, which has none. */
export function emailedInvites<T extends { invitedEmail?: string | null }>(invites: T[]): T[] {
  return invites.filter((i) => !!i.invitedEmail);
}

/**
 * The line under the invite, by the player's age (recordingNotice): a
 * parent is named only for a player under 18.
 */
export function inviteFootnote(minor: boolean, how: 'email' | 'link'): string {
  const recorded = minor
    ? 'Every lesson is recorded, and a parent can watch any recording in the account.'
    : 'Every lesson is recorded.';
  return how === 'link'
    ? `Anyone with this link can open it on any device to watch the lesson. ${recorded}`
    : `A join link will be emailed to them. They can open it on any device to watch the lesson. ${recorded}`;
}

/**
 * The lesson's own guest link, which the server makes at booking
 * (createObserverInvite): the invite with no address, still active.
 */
export function lessonLinkToken(invites: Array<{ token?: string; invitedEmail?: string | null; role?: string; status?: string }>): string | null {
  return invites.find((i) => !i.invitedEmail && i.role === 'observer' && i.status === 'active' && !!i.token)?.token ?? null;
}
